import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import CardHome from '../../components/Cards/CardHome';
import { storageGetItem } from '../../utils/local-storage';
import dashboardApi from '../../apis/dashboard-api';
import FilterDate from '../../components/FilterDate/FilterDate';
import { USER_PROFILE } from '../../utils/storage-keys';
import './HomeLeader.css';
import GlobalStore from '../../stores/global-store';
import TeamDataDetail from './TeamDataDetail';
import getAffiliateId from '../../utils/get_affiliate_id';
import formatCurrency from '../../utils/format-currency';

function HomeLeader() {
  const { setLoading, affID } = GlobalStore.useContainer();
  const userProfile = JSON.parse(storageGetItem(USER_PROFILE));
  const [teamLeadData, setTeamLeadData] = useState({});
  const [teamLeadDataFiltered, setTeamLeadDataFiltered] = useState({});
  const [teamStats, setTeamStats] = useState({
    conversionRate: 0,
    actualRevenue: 0,
    actualCommission: 0,
    deal: 0,
    lead: 0,
    numOfMembers: 0
  });
  const [filterDate, setFilterDate] = useState({
    label: 'Tất cả',
    slug: 'all',
    range: {}
  });
  const [isLeader, setIsLeader] = useState(false);
  const [teamDataGroup, setTeamDataGroup] = useState([]);
  const affiliateID = getAffiliateId();

  const calcRevenuePercent = useCallback((revenue) => {
    if (revenue <= 30000000) {
      return 2;
    } else if (revenue > 30000000 && revenue <= 50000000) {
      return 3;
    } else if (revenue > 50000000 && revenue <= 100000000) {
      return 4;
    } else {
      return 5;
    }
  }, []);

  const groupBy = (array) => {
    const result = array?.reduce((acc, item) => {
      if (item.affiliate_id.toString() === affiliateID) {
        return acc;
      }
      const { affiliate_id } = item;
      const existingCategory = acc.find(c => c[affiliate_id]);
      if (existingCategory) {
        existingCategory[affiliate_id].push(item);
      } else {
        const newCategory = { [affiliate_id]: [item] };
        acc.push(newCategory);
      }
      return acc;
    }, []);
    return result;
  };

  useEffect(() => {
    async function getSummaryDashboard() {
      setLoading(true);
      const responseDashboard = await dashboardApi.getSummaryDashboard(affID);
      setTeamLeadData(responseDashboard?.data?.dashboard);
      setTeamLeadDataFiltered(responseDashboard?.data?.dashboard);
      setLoading(false);
    }

    getSummaryDashboard();
  }, [setLoading]);

  const filterRangeDate = (dateRange, entryDate) => {
    let filterPass = true;
    const date = moment(entryDate).unix();
    if (dateRange.startDate) {
      filterPass = filterPass && (dateRange.startDate <= date);
    }
    if (dateRange.endDate) {
      filterPass = filterPass && (dateRange.endDate >= date);
    }
    return filterPass;
  };

  const teamDataFilterHandler = (dateEntry) => {
    let teamDataFilterTmp = [];
    setFilterDate(dateEntry);

    if (dateEntry.slug !== 'all') {
      const dateRange = {
        startDate: dateEntry.range.startDate,
        endDate: dateEntry.range.endDate
      };

      teamDataFilterTmp = teamLeadData?.team_data.filter(row => {
        return filterRangeDate(dateRange, row.date);
      });

      setTeamLeadDataFiltered(state => ({
        ...state,
        team_data: teamDataFilterTmp
      }));
    } else {
      setTeamLeadDataFiltered(teamLeadData);
    }
  };

  useEffect(() => {
    let isConverted = 0;
    let actualRevenue = 0;
    let deal = 0;

    if (teamLeadDataFiltered && teamLeadDataFiltered.team_data) {
      for (let value of teamLeadDataFiltered.team_data) {
        if (value.is_converted === true) {
          deal++;
        }
        if (value.is_converted === true && value.deal_stage === 'Closed Won') {
          isConverted++;
        }

        if (value.deal_stage === 'Closed Won') {
          actualRevenue += value.lead_amount;
        }
      }
      const percent = calcRevenuePercent(actualRevenue);
  
      setTeamStats(state => ({
        ...state,
        conversionRate: (Math.round((isConverted / teamLeadDataFiltered?.team_data?.length) * 100) / 10 * 10) || 0,
        actualRevenue,
        actualCommission: percent * actualRevenue / 100,
        deal,
        lead: teamLeadDataFiltered?.team_data?.length - deal
      }));
    }

  }, [teamLeadDataFiltered, calcRevenuePercent]);

  useEffect(() => {
    if (teamLeadDataFiltered?.team_data?.length) {
      const groupData = groupBy(teamLeadDataFiltered?.team_data);
      setTeamDataGroup(groupData);
      setTeamStats(state => ({
        ...state,
        numOfMembers: groupData?.length
      }));
    }
  }, [teamLeadDataFiltered]);

  useEffect( () => {
    if (teamLeadData?.team_data && teamLeadData?.team_data.length) {
      setIsLeader(true);
    }
  }, [teamLeadData, setIsLeader] );

  return (
    <div className="page-home container-fluid">
      <div className="d-flex justify-content-end align-items-baseline mb-3">
        <div className="d-flex align-items-center">
          <FilterDate
            onSelectDate={teamDataFilterHandler}
            onSelect={!isLeader}
          />
          <p className='d-none'>{filterDate.label}</p>
        </div>
      </div>
      <hr />
      <h1 className="welcome-message">Xin chào, {userProfile.display_name}!</h1>

      {isLeader && (
        <>
          <section className="section-card">
            <h2 className="section-card__title">Tổng quan</h2>
            <div className="section-card__body">
              <div className="row">
                <div className="col-lg-3">
                  <CardHome
                    iconName="coin"
                    title="Doanh số thực tế"
                    text={(formatCurrency(teamStats.actualRevenue) || 0) + ' đ'}
                    link="/"
                    tooltip="Thể hiện doanh thu chỉ bao gồm đơn hàng đã thanh toán thành công"
                  />
                </div>

                <div className="col-lg-3">
                  <CardHome
                    iconName="coin"
                    title="Hoa hồng thực tế"
                    text={(formatCurrency(teamStats.actualCommission) || 0) + ' đ'}
                    link="/"
                    tooltip="Thể hiện hoa hồng từ những đơn hàng đã thanh toán thành công"
                  />
                </div>

                <div className="col-lg-3">
                  <CardHome
                    iconName="click"
                    title="Deal"
                    text={teamStats.deal}
                    link="/"
                    tooltip="Tổng số deal"
                  />
                </div>

                <div className="col-lg-3">
                  <CardHome
                    iconName="click"
                    title="Lead"
                    text={teamStats.lead}
                    link="/"
                    tooltip="Tổng số lead"
                  />
                </div>

                <div className="col-lg-3">
                  <CardHome
                    iconName="user"
                    iconColor="transparent"
                    iconFill="#9fa6b2"
                    title="Số thành viên"
                    text={teamStats.numOfMembers > 0 ? teamStats.numOfMembers : 0}
                    link=""
                    tooltip="Thể hiện số thành viên trong team của bạn"
                  />
                </div>

                <div className="col-lg-3">
                  <CardHome
                    iconName="balance"
                    title="Tỷ lệ chuyển đổi"
                    text={teamStats.conversionRate + '%'}
                    link="#"
                    tooltip="Thể hiện tỉ lệ chuyển đổi từ đơn hàng đăng ký sang đơn hàng thanh toán thành công"
                  />
                </div>
              </div>
            </div>
          </section>

          <TeamDataDetail
            teamDataGrouped={teamDataGroup}
          />
        </>
      )}
      {!isLeader && <p className='text-muted'>Bạn chưa có thành viên nào!</p>}
    </div>
  )
}

export default HomeLeader;
